import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Image, X, ChevronLeft, ChevronRight, ZoomIn, ArrowRight, 
  Folder, FolderOpen, ArrowLeft, Calendar, MapPin, Grid, 
  Play, Pause, Maximize2, Sparkles, Film, Eye, Layers 
} from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Testimonials from '../components/sections/Testimonials';
import { Helmet } from 'react-helmet-async';

// Album mapper
const ALBUMS = [
  {
    id: 'gensyns-match-2026-korsor',
    title: 'GENSYNS MATCH 2026 I KORSØR',
    category: 'Begivenheder & Matcher',
    date: '2026',
    location: 'Korsør Golfklub',
    description: 'Se alle de gode minder, glade deltagere og hyggelige stunder fra Gensyns Match 2026 i Korsør.',
    coverImage: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3662.jpg',
    images: [
      {
        id: 'gensyn-2026-3662',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3662.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3660',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3660.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3657',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3657.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3653',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3653.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3652',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3652.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3649',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3649.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3646',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3646.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3645',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3645.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3643',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3643.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3640',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3640.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3639',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3639.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3638',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3638.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3637',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3637.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3636',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3636.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3635',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3635.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3634',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3634.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3633',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3633.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3667',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3667.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3665',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3665.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      },
      {
        id: 'gensyn-2026-3664',
        image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/img-3664.jpg',
        title: 'Gensyns Match 2026 i Korsør',
        category: 'GENSYNS MATCH 2026 I KORSØR',
        description: 'Billeder fra Gensyns Match 2026 i Korsør.'
      }
    ]
  }
];

// Generelle stemningsbilleder fra destinationen
const GENERAL_IMAGES = [
  {
    id: 'strandpromenade',
    image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/5bf7338c-0dcf-4571-b74a-3898054482b8.jpeg',
    title: 'Strandpromenaden i La Barrosa',
    category: 'Strand & By',
    description: 'Den hyggelige strandpromenade med caféer og restauranter lige ud til det gyldne sand.'
  },
  {
    id: 'strandpromenade2',
    image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/d92325fd-869b-4753-9024-1f227ac3c53b.jpeg',
    title: 'Aftenstemning på promenaden',
    category: 'Strand & By',
    description: 'Smuk udsigt over stranden og promenaden i det bløde eftermiddagslys.'
  },
  {
    id: 'novo',
    image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/429dbfab-5e67-4707-a52a-146714ba2689.jpeg',
    title: 'Novo Sancti Petri',
    category: 'Golf',
    description: 'Aparthotel 150m fra stranden og tæt på golfbanerne.'
  },
  {
    id: 'lajab',
    image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/85f977ee-05da-46fe-a72b-c4841ad8ddff.jpg',
    title: 'Første række til Atlanterhavet',
    category: 'Strand & By',
    description: 'Den brede, hvide sandstrand og det krystalklare Atlanterhav.'
  },
  {
    id: 'amanecer',
    image: 'https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/b5450222-999a-4cfa-96f3-23504e16fdc8.jpg',
    title: 'Amanecer',
    category: 'Natur',
    description: 'Første række til Atlanterhavet med betagende solnedgange.'
  }
];

const GalleriPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialAlbumId = searchParams.get('album');
  const [selectedAlbumId, setSelectedAlbumId] = useState(initialAlbumId || null);
  const [selectedCategory, setSelectedCategory] = useState('Alle');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  // Sync state with URL query param if changed
  const handleSelectAlbum = (albumId) => {
    setSelectedAlbumId(albumId);
    if (albumId) {
      setSearchParams({ album: albumId });
    } else {
      setSearchParams({});
    }
  };

  // Scroll to top on mount or when album changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedAlbumId]);

  const activeAlbum = ALBUMS.find((a) => a.id === selectedAlbumId);

  // Album Live Collage Slider State
  const [sliderIndex, setSliderIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  // Reset slider index when album changes
  useEffect(() => {
    setSliderIndex(0);
    setIsPlaying(true);
  }, [selectedAlbumId]);

  // Autoplay for the Live Collage Slider
  useEffect(() => {
    if (!activeAlbum || !isPlaying || isHovered || lightboxOpen) return;

    const timer = setInterval(() => {
      setSliderIndex((prev) => (prev + 1) % activeAlbum.images.length);
    }, 4200);

    return () => clearInterval(timer);
  }, [activeAlbum, isPlaying, isHovered, lightboxOpen]);

  const handleNextSlide = () => {
    if (!activeAlbum) return;
    setSliderIndex((prev) => (prev + 1) % activeAlbum.images.length);
  };

  const handlePrevSlide = () => {
    if (!activeAlbum) return;
    setSliderIndex((prev) => (prev === 0 ? activeAlbum.images.length - 1 : prev - 1));
  };

  // Determine current image list for lightbox
  const currentImagesList = activeAlbum
    ? activeAlbum.images
    : (selectedCategory === 'Alle'
        ? GENERAL_IMAGES
        : GENERAL_IMAGES.filter((img) => img.category === selectedCategory));

  // Extract unique categories for general images
  const generalCategories = ['Alle', ...new Set(GENERAL_IMAGES.map((img) => img.category))].filter(Boolean);

  // Lightbox navigation
  const openLightbox = (index) => {
    setActiveImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = useCallback((e) => {
    e?.stopPropagation();
    setActiveImageIndex((prev) => (prev === currentImagesList.length - 1 ? 0 : prev + 1));
  }, [currentImagesList]);

  const prevImage = useCallback((e) => {
    e?.stopPropagation();
    setActiveImageIndex((prev) => (prev === 0 ? currentImagesList.length - 1 : prev - 1));
  }, [currentImagesList]);

  // Keyboard navigation for lightbox
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, nextImage, prevImage]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Helmet>
        <title>{activeAlbum ? `${activeAlbum.title} | Galleri | Golf4Life` : 'Galleri & Albums | Golf4Life - Billeder fra vores golfrejser'}</title>
        <meta name="description" content="Se billeder og albummer fra vores longstay golfrejser til Andalusien samt gensynsmatcher i Danmark." />
      </Helmet>

      <Navbar solid={true} />

      <main className="pt-20 md:pt-24">
        {activeAlbum ? (
          /* =========================================================================
             ALBUM HERO SLIDER (Erstatter heroen på albumsiden. Billeder beskæres ikke!)
             ========================================================================= */
          <section 
            className="bg-slate-950 text-white border-b border-slate-800"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* Top Bar / Header */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-4">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => handleSelectAlbum(null)}
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-slate-900 hover:bg-slate-800 text-slate-200 hover:text-white text-sm font-medium border border-slate-700/80 transition-all cursor-pointer shadow-sm"
                  >
                    <ArrowLeft size={16} />
                    Tilbage til alle mapper
                  </button>

                  <span className="text-slate-600">/</span>

                  <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-white truncate">
                    {activeAlbum.title}
                  </h1>
                </div>

                {/* Controls & Counter */}
                <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
                  <div className="px-3.5 py-1.5 rounded-lg bg-slate-900 border border-slate-800 text-emerald-400 text-xs sm:text-sm font-mono font-medium">
                    {sliderIndex + 1} / {activeAlbum.images.length}
                  </div>

                  <button
                    onClick={() => setIsPlaying(!isPlaying)}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-slate-300 hover:text-white text-xs font-semibold border border-slate-800 transition-all cursor-pointer"
                    title={isPlaying ? 'Pause slideshow' : 'Afspil slideshow'}
                  >
                    {isPlaying ? <Pause size={14} className="text-amber-400" /> : <Play size={14} className="text-emerald-400 fill-emerald-400" />}
                    <span>{isPlaying ? 'Pause' : 'Afspil'}</span>
                  </button>

                  <button
                    onClick={() => openLightbox(sliderIndex)}
                    className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-bold transition-all shadow-sm cursor-pointer"
                  >
                    <Maximize2 size={14} />
                    <span>Fuld skærm</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Slider Main Stage — Billeder beskæres IKKE (object-contain) */}
            <div className="relative w-full bg-slate-950 flex items-center justify-center py-2 px-2 sm:px-4">
              <div className="relative w-full max-w-6xl mx-auto flex items-center justify-center h-[52vh] sm:h-[60vh] md:h-[65vh] min-h-[380px] max-h-[700px]">
                <div
                  onClick={() => openLightbox(sliderIndex)}
                  className="w-full h-full flex items-center justify-center cursor-pointer relative group select-none py-1"
                >
                  <img
                    key={activeAlbum.images[sliderIndex]?.image || sliderIndex}
                    src={activeAlbum.images[sliderIndex]?.image}
                    alt={`${activeAlbum.title} - foto ${sliderIndex + 1}`}
                    className="w-auto h-full max-h-full max-w-full object-contain rounded-lg shadow-2xl transition-opacity duration-300"
                  />

                  {/* Gentle hover prompt to expand */}
                  <div className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4 opacity-0 group-hover:opacity-100 transition-opacity bg-slate-900/90 backdrop-blur-md text-white text-xs px-3 py-1.5 rounded-full border border-white/10 flex items-center gap-1.5 pointer-events-none">
                    <ZoomIn size={13} />
                    Klik for fuld skærm
                  </div>
                </div>

                {/* Prev / Next Arrows */}
                <button
                  onClick={(e) => { e.stopPropagation(); handlePrevSlide(); }}
                  className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-20 p-2.5 sm:p-3 rounded-full bg-slate-900/80 hover:bg-emerald-600 text-white backdrop-blur-md transition-all shadow-lg cursor-pointer border border-white/10"
                  aria-label="Forrige billede"
                >
                  <ChevronLeft size={22} />
                </button>
                <button
                  onClick={(e) => { e.stopPropagation(); handleNextSlide(); }}
                  className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-20 p-2.5 sm:p-3 rounded-full bg-slate-900/80 hover:bg-emerald-600 text-white backdrop-blur-md transition-all shadow-lg cursor-pointer border border-white/10"
                  aria-label="Næste billede"
                >
                  <ChevronRight size={22} />
                </button>
              </div>
            </div>

            {/* Slider Thumbnail Filmstrip */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
              <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-thin scrollbar-thumb-slate-700 scrollbar-track-slate-950">
                {activeAlbum.images.map((img, idx) => (
                  <button
                    key={img.id}
                    onClick={() => setSliderIndex(idx)}
                    className={`relative flex-shrink-0 w-16 h-12 sm:w-20 sm:h-14 rounded-md overflow-hidden border-2 transition-all cursor-pointer ${
                      sliderIndex === idx 
                        ? 'border-emerald-400 ring-2 ring-emerald-400/40 opacity-100 scale-105' 
                        : 'border-slate-800 opacity-50 hover:opacity-100 hover:border-slate-600'
                    }`}
                    title={`Billede ${idx + 1}`}
                  >
                    <img
                      src={img.image}
                      alt={`Thumbnail ${idx + 1}`}
                      className="w-full h-full object-cover"
                    />
                    <span className="absolute bottom-0.5 right-1 text-[9px] font-bold text-white drop-shadow-md bg-black/60 px-1 rounded">
                      {idx + 1}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </section>
        ) : (
          /* Standard Overview Hero */
          <section className="relative h-[40vh] md:h-[48vh] min-h-[340px] overflow-hidden">
            <div className="absolute inset-0">
              <img 
                src="https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/397666f3-e4fa-4a9c-bd59-49645054de02.jpg" 
                alt="Golf4Life Galleri" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-slate-900/80 to-slate-950/40" />
              <div className="absolute inset-0 bg-radial-at-c from-transparent via-slate-950/40 to-slate-950/80 pointer-events-none" />
            </div>

            <div className="absolute inset-0 flex items-center">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                <div className="max-w-2xl text-white">
                  <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 text-white text-sm font-medium mb-4 backdrop-blur-sm border border-white/10">
                    <Image size={16} />
                    Billedgalleri & Albums
                  </span>
                  <h1 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
                    Oplev stemningen og fællesskabet
                  </h1>
                  <p className="text-base md:text-lg text-slate-200 mb-6 max-w-xl">
                    Gennemse vores fotoalbums fra matcher, arrangementer og de skønne omgivelser i Andalusien.
                  </p>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ACTIVE ALBUM DETAIL VIEW (Grid under slider heroen) */}
        {activeAlbum ? (
          <section className="py-10 md:py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="pt-2">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8 pb-4 border-b border-slate-200">
                <div>
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-200 text-slate-700 text-xs font-bold uppercase tracking-wider mb-2">
                    <Grid size={14} />
                    Komplet Fotoliste
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">
                    Alle billeder fra {activeAlbum.title}
                  </h3>
                  <p className="text-slate-600 text-sm mt-1">
                    Klik på ethvert foto for at åbne det i fuld skærm og bladre i lightboxen.
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <span className="px-4 py-2 bg-emerald-50 text-emerald-800 border border-emerald-200 rounded-full text-sm font-semibold inline-flex items-center gap-2">
                    <Image size={16} />
                    {activeAlbum.images.length} billeder
                  </span>
                </div>
              </div>

              {/* Album Images Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {activeAlbum.images.map((img, index) => (
                  <motion.div
                    key={img.id}
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.02 }}
                    onClick={() => openLightbox(index)}
                    className="group relative aspect-[4/3] rounded-2xl overflow-hidden bg-slate-200 border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
                  >
                    <img
                      src={img.image}
                      alt={`${activeAlbum.title} - billede ${index + 1}`}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    
                    {/* Overlay on hover */}
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-200 flex flex-col justify-end p-4">
                      <span className="inline-flex items-center gap-1.5 text-xs text-emerald-300 font-medium">
                        <ZoomIn size={14} />
                        Klik for at forstørre
                      </span>
                    </div>

                    <span className="absolute top-3 right-3 px-2.5 py-1 bg-slate-900/70 backdrop-blur-sm text-white text-xs font-semibold rounded-md">
                      #{index + 1}
                    </span>
                  </motion.div>
                ))}
              </div>

              <div className="mt-12 text-center">
                <button
                  onClick={() => handleSelectAlbum(null)}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-slate-800 font-semibold border border-slate-300 shadow-sm hover:bg-slate-50 transition-all cursor-pointer"
                >
                  <ArrowLeft size={18} />
                  Luk mappe og se alle albums
                </button>
              </div>
            </div>

          </section>
        ) : (
          /* OVERVIEW: ALBUM FOLDERS & GENERAL GALLERY */
          <section className="py-12 md:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
            
            {/* SECTION 1: ALBUM MAPPER */}
            <div>
              <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 pb-4 border-b border-slate-200">
                <div>
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-100/80 text-emerald-800 text-xs font-bold uppercase tracking-wider mb-2">
                    <Folder size={14} />
                    Billedmapper & Begivenheder
                  </div>
                  <h2 className="text-2xl md:text-3xl font-bold text-slate-900">
                    Arrangementer & Matcher
                  </h2>
                  <p className="text-slate-600 mt-1">
                    Klik på en mappe for at åbne albummet og se alle billederne.
                  </p>
                </div>
              </div>

              {/* Album Folders Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {ALBUMS.map((album) => (
                  <motion.div
                    key={album.id}
                    whileHover={{ y: -6 }}
                    transition={{ duration: 0.2 }}
                    onClick={() => handleSelectAlbum(album.id)}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-slate-200 hover:border-[var(--brand)] shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer flex flex-col"
                  >
                    {/* Folder Preview with stack visual effect */}
                    <div className="relative aspect-[16/10] overflow-hidden bg-slate-900">
                      <img
                        src={album.coverImage}
                        alt={album.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/20 to-transparent" />
                      
                      {/* Folder Badge */}
                      <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-700/90 backdrop-blur-md text-white text-xs font-bold shadow-md">
                        <FolderOpen size={14} />
                        Mappe
                      </div>

                      {/* Photo Count Badge */}
                      <div className="absolute top-4 right-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-slate-900/80 backdrop-blur-md text-white text-xs font-semibold shadow-md">
                        <Image size={14} />
                        {album.images.length} billeder
                      </div>

                      {/* Title overlay in image */}
                      <div className="absolute bottom-4 left-4 right-4 text-white">
                        <div className="flex items-center gap-2 text-emerald-300 text-xs font-semibold mb-1">
                          {album.location && (
                            <span className="flex items-center gap-1">
                              <MapPin size={12} />
                              {album.location}
                            </span>
                          )}
                          <span>•</span>
                          <span>{album.date}</span>
                        </div>
                        <h3 className="text-xl font-bold leading-tight group-hover:text-emerald-300 transition-colors">
                          {album.title}
                        </h3>
                      </div>
                    </div>

                    {/* Card Content & Action */}
                    <div className="p-6 flex-1 flex flex-col justify-between bg-white">
                      <p className="text-slate-600 text-sm mb-6 leading-relaxed">
                        {album.description}
                      </p>

                      <div className="pt-4 border-t border-slate-100 flex items-center justify-between">
                        <span className="text-xs font-medium text-slate-500">
                          {album.images.length} fotos i albummet
                        </span>
                        <span className="inline-flex items-center gap-2 text-sm font-bold text-[var(--brand)] group-hover:translate-x-1 transition-transform">
                          Åbn album
                          <ArrowRight size={16} />
                        </span>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* SECTION 2: STEMNINGSBILLEDER FRA DESTINATIONEN */}
            <div className="pt-8 border-t border-slate-200">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-8">
                <div>
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-200 text-slate-700 text-xs font-bold uppercase tracking-wider mb-2">
                    <Grid size={14} />
                    Stemningsbilleder
                  </div>
                  <h2 className="text-2xl md:text-3xl font-bold text-slate-900">
                    Oplev Destinationen & Omgivelserne
                  </h2>
                  <p className="text-slate-600 mt-1">
                    Billeder fra strandpromenaden, boligerne og de smukke omgivelser i Novo Sancti Petri.
                  </p>
                </div>

                <div className="flex flex-wrap gap-2">
                  {generalCategories.map((category) => (
                    <button
                      key={category}
                      onClick={() => setSelectedCategory(category)}
                      className={`px-4 py-2 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer ${
                        selectedCategory === category
                          ? 'bg-[var(--brand)] text-white shadow-md shadow-emerald-900/20'
                          : 'bg-white text-slate-600 hover:bg-slate-100 border border-slate-200'
                      }`}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>

              {/* General Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                <AnimatePresence mode="popLayout">
                  {currentImagesList.map((img, index) => (
                    <motion.div
                      layout
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.9 }}
                      transition={{ duration: 0.3 }}
                      key={img.id}
                      onClick={() => openLightbox(index)}
                      className="group relative aspect-[4/3] rounded-2xl overflow-hidden bg-slate-200 border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-500 cursor-pointer"
                    >
                      <img
                        src={img.image}
                        alt={img.title}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />
                      
                      {/* Dark Overlay on Hover */}
                      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/40 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col justify-end p-6">
                        <span className="text-xs font-semibold uppercase tracking-wider text-emerald-400 mb-1">
                          {img.category}
                        </span>
                        <h3 className="text-white font-semibold text-lg leading-snug mb-2">
                          {img.title}
                        </h3>
                        <p className="text-xs text-slate-300 mb-4 line-clamp-2">
                          {img.description}
                        </p>
                        <span className="inline-flex items-center gap-1.5 text-xs text-emerald-400 font-medium">
                          <ZoomIn size={14} />
                          Klik for at forstørre
                        </span>
                      </div>

                      {/* Category Tag */}
                      <span className="absolute top-4 left-4 px-3 py-1 bg-slate-900/70 backdrop-blur-sm text-white text-xs font-semibold rounded-full group-hover:opacity-0 transition-opacity duration-300">
                        {img.category}
                      </span>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </div>
            </div>

          </section>
        )}

        {/* Testimonials Section */}
        <Testimonials />

        {/* Call to Action Section */}
        <section className="py-20 bg-[var(--brand)] text-white relative overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <img 
              src="https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/88393245-95da-4648-8ed7-33384daecaa2.jpg" 
              alt="Golfbane baggrund" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6">
              Vil du opleve det hele med egne øjne?
            </h2>
            <p className="text-lg md:text-xl text-emerald-100/90 max-w-2xl mx-auto mb-10 leading-relaxed">
              Vores longstay golfrejser til Andalusien er utroligt populære, og pladserne bliver hurtigt udsolgt. Kontakt os i dag for at høre mere om dine muligheder.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[var(--brand)] hover:bg-slate-100 font-bold rounded-full transition-all shadow-lg shadow-black/10"
              >
                Kontakt os nu
                <ArrowRight size={18} />
              </Link>
              <Link
                to="/ophold"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold rounded-full transition-all"
              >
                Se vores ophold
              </Link>
            </div>
          </div>
        </section>

        {/* Lightbox / Modal */}
        <AnimatePresence>
          {lightboxOpen && (() => {
            const currentImageObj = currentImagesList[activeImageIndex];
            if (!currentImageObj) return null;
            
            const imageUrl = currentImageObj.image;
            const titleText = currentImageObj.title;
            const categoryText = currentImageObj.category;
            const descriptionText = currentImageObj.description;

            return (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 z-[100] bg-slate-950/95 backdrop-blur-md flex flex-col justify-between p-4 md:p-8"
                onClick={closeLightbox}
              >
                {/* Top Bar */}
                <div className="flex justify-between items-center text-white w-full max-w-7xl mx-auto z-10">
                  <div>
                    <span className="text-xs font-semibold uppercase tracking-wider text-emerald-400">
                      {categoryText}
                    </span>
                    <h3 className="text-lg md:text-xl font-medium">
                      {titleText}
                    </h3>
                  </div>
                  <button
                    onClick={closeLightbox}
                    className="p-3 rounded-full bg-white/10 hover:bg-white/20 text-white transition-all focus:outline-none cursor-pointer"
                    aria-label="Luk galleri"
                  >
                    <X size={24} />
                  </button>
                </div>

                {/* Main Image Container */}
                <div className="relative flex-1 flex items-center justify-center max-w-5xl mx-auto w-full my-4">
                  {/* Prev Button */}
                  {currentImagesList.length > 1 && (
                    <button
                      onClick={prevImage}
                      className="absolute left-4 p-3 md:p-4 rounded-full bg-slate-900/60 hover:bg-slate-900/80 text-white transition-all focus:outline-none z-10 backdrop-blur-sm drop-shadow-md cursor-pointer"
                      aria-label="Forrige billede"
                    >
                      <ChevronLeft size={32} />
                    </button>
                  )}

                  {/* Image */}
                  <img
                    src={imageUrl}
                    alt={titleText}
                    className="max-h-[70vh] md:max-h-[80vh] max-w-full object-contain rounded-lg shadow-2xl select-none"
                    onClick={(e) => e.stopPropagation()}
                  />

                  {/* Next Button */}
                  {currentImagesList.length > 1 && (
                    <button
                      onClick={nextImage}
                      className="absolute right-4 p-3 md:p-4 rounded-full bg-slate-900/60 hover:bg-slate-900/80 text-white transition-all focus:outline-none z-10 backdrop-blur-sm drop-shadow-md cursor-pointer"
                      aria-label="Næste billede"
                    >
                      <ChevronRight size={32} />
                    </button>
                  )}
                </div>

                {/* Bottom Bar / Counter */}
                <div className="text-center text-slate-400 text-sm pb-2 z-10 max-w-xl mx-auto">
                  <p className="text-slate-300 mb-2">{descriptionText}</p>
                  <div>
                    Billede {activeImageIndex + 1} af {currentImagesList.length}
                  </div>
                </div>
              </motion.div>
            );
          })()}
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
};

export default GalleriPage;
